import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

// Angular Material Imports
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { environment } from '../../../environments/environment';

/**
 * Shown when a user is authenticated (valid Cognito/SSO session) but their
 * {org}-Users record has not been activated by an administrator. Routed to by the
 * auth guard's activation gate. Top-level route (not under /securehome) so the
 * guard never runs on it.
 */
@Component({
  selector: 'app-pending-activation',
  templateUrl: './pending-activation.component.html',
  styleUrls: ['./pending-activation.component.css'],
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatIconModule],
})
export class PendingActivationComponent {
  private router = inject(Router);

  // Strip any trailing period so the sentence in the template (which adds its own
  // period) doesn't render a double period for names like "…, Inc.".
  readonly orgFormalName = (environment.orgFormalName || '').replace(/\s*\.+\s*$/, '');

  // environment.orgLocalAdministrator is a loosely-formatted string that may
  // embed a mailto anchor fragment (e.g. 'Kimberley Harris <a href="mailto:x@y">').
  // Parse it defensively into a plain name + optional email so we never render
  // raw/half-formed HTML into the page.
  readonly adminName: string;
  readonly adminEmail: string | null;

  constructor() {
    const raw = environment.orgLocalAdministrator || '';
    const emailMatch = raw.match(/mailto:([^"'>\s]+)/i);
    this.adminEmail = emailMatch ? emailMatch[1] : null;
    // Name is whatever precedes the first '<' (the anchor fragment), trimmed.
    this.adminName = raw.split('<')[0].trim();
  }

  logout(): void {
    // Reuse the existing logout route, which clears the session and returns to /login.
    this.router.navigate(['/logout']);
  }
}
